import { DribbbleLogo, InstagramLogo, WhatsappLogo } from "phosphor-react";
import React from "react";

const Index = () => {
  const year_time = new Date().getFullYear();
  return (
    <>
      <div className="md:flex md:justify-between bg-slate-900 !text-white py-12 px-4 lg:px-24">
        <div className="flex flex-col mb-6 md:mb-0 md:mr-6">
          <div className="mb-4">
            <svg
              className="!fill-white"
              width="91"
              height="19"
              viewBox="0 0 91 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0.776003 17.712C0.440003 17.36 0.272003 16.808 0.272003 16.056C0.272003 15.304 0.440003 14.76 0.776003 14.424C1.128 14.072 1.68 13.896 2.432 13.896C3.184 13.896 3.728 14.072 4.064 14.424C4.416 14.76 4.592 15.304 4.592 16.056C4.592 16.808 4.416 17.36 4.064 17.712C3.728 18.048 3.184 18.216 2.432 18.216C1.68 18.216 1.128 18.048 0.776003 17.712Z" />
              <path d="M10.8832 18H7.49919V1.20001H12.9952L18.1072 14.232L23.1712 1.20001H28.6672V18H25.3072V4.65601L19.9792 18H16.1872L10.8832 4.68001V18Z" />
              <path d="M40.0325 0.984009C43.0405 0.984009 45.2245 1.66401 46.5845 3.02401C47.9605 4.38401 48.6485 6.57601 48.6485 9.60001C48.6485 12.608 47.9605 14.8 46.5845 16.176C45.2245 17.536 43.0405 18.216 40.0325 18.216C37.0085 18.216 34.8165 17.536 33.4565 16.176C32.0965 14.8 31.4165 12.608 31.4165 9.60001C31.4165 6.57601 32.0965 4.38401 33.4565 3.02401C34.8165 1.66401 37.0085 0.984009 40.0325 0.984009ZM36.0245 5.44801C35.1925 6.31201 34.7765 7.69601 34.7765 9.60001C34.7765 11.504 35.1925 12.888 36.0245 13.752C36.8565 14.616 38.1925 15.048 40.0325 15.048C41.8725 15.048 43.2085 14.616 44.0405 13.752C44.8725 12.888 45.2885 11.504 45.2885 9.60001C45.2885 7.69601 44.8725 6.31201 44.0405 5.44801C43.2085 4.56801 41.8725 4.12801 40.0325 4.12801C38.1925 4.12801 36.8565 4.56801 36.0245 5.44801Z" />
              <path d="M49.2836 1.20001H52.8596L58.6196 14.448L64.3556 1.20001H67.9556L60.5156 18H56.7236L49.2836 1.20001Z" />
              <path d="M70.007 18V1.20001H73.391V18H70.007Z" />
              <path d="M90.6793 18H76.6633V1.20001H90.6793V4.36801H80.0473V8.11201H89.4793V11.088H80.0473V14.832H90.6793V18Z" />
            </svg>
          </div>
          <h1 className="text-lg lg:text-4xl font-bold mb-2">
            Ready to get started?
          </h1>
          <p className="text-slate-200 font-light mb-4">
            The fastest simple way to generate growing business solutions with
            our products
          </p>
          <div className="flex mb-6 bg-white p-3 rounded-2xl space-x-3">
            <input
              id="large-input"
              type="email"
              placeholder="Your business email"
              className="block p-4 text-gray-900 rounded-lg sm:text-md outline-0 w-full"
            />
            <button className="flex w-60 items-center justify-center py-4 px-8 bg-sky-500 text-white rounded-xl transition-all duration-300 ease-in-out hover:bg-sky-600">
              Get Started
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 sm:!gap-4 md:!gap-16 sm:grid-cols-3">
          <div>
            <h2 className="mb-4 text-sm font-semibold text-white">
              Orginal Series
            </h2>
            <ul className="text-gray-600 dark:text-gray-400">
              <li className="py-2">
                <a href="/" className="hover:underline">
                  Apple Tv+
                </a>
              </li>
              <li className="py-2">
                <a href="/" className="hover:underline">
                  Disney+
                </a>
              </li>
              <li className="py-2">
                <a href="/" className="hover:underline">
                  HBO
                </a>
              </li>
              <li className="py-2">
                <a href="/" className="hover:underline">
                  Netflix
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h2 className="mb-4 text-sm font-semibold text-white">Category</h2>
            <ul className="text-gray-600 dark:text-gray-400">
              <li className="py-2">
                <a href="/" className="hover:underline">
                  Action
                </a>
              </li>
              <li className="py-2">
                <a href="/" className="hover:underline">
                  Adventure
                </a>
              </li>
              <li className="py-2">
                <a href="/" className="hover:underline">
                  Animation
                </a>
              </li>
              <li className="py-2">
                <a href="/" className="hover:underline">
                  Drama
                </a>
              </li>
              <li className="py-2">
                <a href="/" className="hover:underline">
                  Horror
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h2 className="mb-4 text-sm font-semibold text-white">.Movie</h2>
            <ul className="text-gray-600 dark:text-gray-400">
              <li className="py-2">
                <a href="/" className="hover:underline">
                  About Us
                </a>
              </li>
              <li className="py-2">
                <a href="/movies" className="hover:underline">
                  Movies
                </a>
              </li>
              <li className="py-2">
                <a href="/genres" className="hover:underline">
                  Genres
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="py-6 px-4 lg:px-24 bg-slate-800 !text-center justify-center md:flex md:items-center md:justify-between">
        <span className="text-sm text-gray-300 sm:text-center">
          © {year_time}
          <a
            className="bg-blue-500/10 px-2 py-1 rounded-lg mx-1 inline-block transition-all duration-300 ease-in-out hover:-translate-y-2"
            href="https://vahidabbasiy.ir"
          >
            vahidabbasiy ™
          </a>
          . All Rights Reserved. Designed By
          <a
            className="bg-pink-400/10 px-2 py-1 rounded-lg mx-1 inline-block transition-all duration-300 ease-in-out hover:-translate-y-2"
            href="https://dribbble.com/imlahmacun"
          >
            Royhan ™
          </a>
        </span>
        <div className="flex mt-4 space-x-6 justify-center md:mt-0">
          <a
            href="https://instagram.com/aden.uix"
            className="text-gray-400 hover:text-blue-500 transition-all duration-300 ease-in-out hover:-translate-y-2"
          >
            <InstagramLogo size={24} />
          </a>
          <a
            href="https://wa.me/+989120671263"
            className="text-gray-400 hover:text-green-500 transition-all duration-300 ease-in-out hover:-translate-y-2"
          >
            <WhatsappLogo size={24} />
          </a>
          <a
            href="https://dribbble.com/adenuix"
            className="text-gray-400 hover:text-pink-500 transition-all duration-300 ease-in-out hover:-translate-y-2"
          >
            <DribbbleLogo size={24} />
          </a>
        </div>
      </div>
    </>
  );
};

export default Index;
